import React, { useEffect, useState } from "react";
import { Tag } from "antd";
import moment from "moment";

/**
 * 24h SLA countdown for a pending report.
 *   - red "OVERDUE" once the deadline has passed
 *   - orange when under 6 hours remain
 *   - green otherwise
 * For non-pending reports it shows a static dash.
 */
const SlaTimer = ({ deadline, status }) => {
  const [, force] = useState(0);

  useEffect(() => {
    if (status && status !== "pending") return undefined;
    const t = setInterval(() => force((n) => n + 1), 60 * 1000);
    return () => clearInterval(t);
  }, [status]);

  if (status && status !== "pending") {
    return <span style={{ color: "#999" }}>—</span>;
  }
  if (!deadline) {
    return <span style={{ color: "#999" }}>—</span>;
  }

  const dl = moment(deadline);
  const now = moment();
  const diffMs = dl.diff(now);

  if (diffMs <= 0) {
    return <Tag color="red">OVERDUE {dl.fromNow()}</Tag>;
  }

  const hoursLeft = diffMs / (1000 * 60 * 60);
  const label = dl.fromNow(true) + " left";
  const color = hoursLeft < 6 ? "orange" : "green";
  return <Tag color={color}>{label}</Tag>;
};

export default SlaTimer;
